<script>
import Layout from "@layouts/form";
import RelatorioTipo from "@forms/RelatorioTipo";

export default {
  page: {
    title: "Detalhes | Tipo de relatório"
  },
  components: { Layout, RelatorioTipo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tipo de relatório",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tipo de Relatório",
          href: "/RelatorioTipo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <RelatorioTipo :editable="editable"></RelatorioTipo>
    </div>
  </Layout>
</template>
